import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { MatchesSlider } from './MatchesSlider';
import { useResetSelection } from './hooks';
import { WidgetHeader } from '../../../../../../common/react/components/WidgetHeader';
import { HeaderButton } from './HeaderButton';
import { UPDATE_ITEM } from '../../../../store/js/modules/video-hub/view-by-match/actions';
import { viewByMatchSelector } from '../../../../store/js/modules/video-hub/view-by-match/selectors';

export const VideoHubViewByMatch = ({ title, anchorName }) => {
    const dispatch = useDispatch();
    const activeIndex = useSelector(viewByMatchSelector)?.activeIndex;
    const buttonClickHandler = () => {
        // reset active button index
        dispatch(
            UPDATE_ITEM.request({
                item: 'activeIndex',
                value: -1
            })
        );
    };

    useResetSelection();

    return (
        <div className="video-hub-view-by-match">
            <div className="wrapper" style={{ marginBottom: 0 }}>
                <WidgetHeader
                    title={title}
                    customArrow={
                        <HeaderButton
                            activeIndex={activeIndex}
                            buttonClickHandler={buttonClickHandler}
                        />
                    }
                />
                <MatchesSlider anchorName={anchorName} />
            </div>
        </div>
    );
};

VideoHubViewByMatch.propTypes = {
    title: PropTypes.string,
    anchorName: PropTypes.string
};
